import { render, staticRenderFns } from "./DebtorForm.vue?vue&type=template&id=62509224&"
import script from "./DebtorForm.vue?vue&type=script&lang=js&"
export * from "./DebtorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports